<template>
    <NuxtLink
        :to="tileLink?.url"
        :target="tileLink?.target"
        class="group rounded-card-md relative h-full overflow-hidden"
        :class="{
            'border-neutral-base border': tile.BorderAroundTile,
            'surface-primary': !isEmpty(tile.ColorPalette),
        }"
    >
        <div class="relative h-full">
            <div
                ref="textContainer"
                class="text-neutral-base relative grid h-full space-y-3 p-6"
                :class="{
                    'text-center': tile.TextPosition === 'centred',
                    'text-left': tile.TextPosition !== 'centred',
                    'justify-start': ['top-left', 'left', 'bottom-left'].includes(tile.ContentPosition),
                    'justify-center': ['top', 'center', 'bottom'].includes(tile.ContentPosition),
                    'justify-end': ['top-right', 'right', 'bottom-right'].includes(tile.ContentPosition),
                    'content-start': ['top-left', 'top', 'top-right'].includes(tile.ContentPosition),
                    'content-center': ['left', 'center', 'right'].includes(tile.ContentPosition),
                    'content-end': ['bottom-left', 'bottom', 'bottom-right'].includes(tile.ContentPosition),
                }"
            >
                <div
                    v-if="tile.Icon?.name"
                    :class="{
                        'flex justify-center': tile.TextPosition === 'centred',
                    }"
                >
                    <DIcon
                        :size="iconSize"
                        :icon="iconName(tile.Icon)"
                        class="shape-brand-accent"
                    />
                </div>

                <BlocksTileLayoutBlockCounterAnimation
                    v-if="tile.NumberCountAnimation && tile.NumberCountValue"
                    :prefix="tile.NumberCountPrefix"
                    :value="tile.NumberCountValue"
                    :suffix="tile.NumberCountSuffix"
                    :color="tile.NumberCountColour"
                    :alignment="tile.TextPosition"
                />

                <p
                    v-if="tile.Subheading"
                    class="leading-sm font-ux text-sm font-(--font-weight-subheading) tracking-wider uppercase"
                    :class="{
                        'text-neutral-strong opacity-90': tile.SubHeadingColour !== 'accent',
                        'text-subheading': tile.SubHeadingColour === 'accent',
                    }"
                >
                    {{ tile.Subheading }}
                </p>
                <p
                    v-if="tile.Heading"
                    class="font-brand-heading font-heading text-heading"
                    :class="{
                        'leading-xl text-xl': ['sm', null].includes(tile.TextSize),
                        'leading-5xl text-5xl': tile.TextSize === 'md',
                        'leading-6xl text-6xl': tile.TextSize === 'lg',
                    }"
                >
                    {{ tile.Heading }}
                </p>
                <p
                    v-if="tile.TextOnHover"
                    class="leading-base font-ux text-base font-normal whitespace-pre-wrap text-(--text-body)"
                >
                    {{ tile.TextOnHover }}
                </p>
                <div v-if="tileLink?.text">
                    <div class="inline-flex">
                        <DButton :theme="buttonTheme(tileLink.buttonStyle)">
                            {{ tileLink.text }}
                        </DButton>
                    </div>
                </div>
            </div>
        </div>
    </NuxtLink>
</template>

<script setup>
    import { DButton, DIcon } from '@digistorm/spark'

    const { iconName } = useIcons()

    const { buttonTheme } = useButtonTheme()

    const props = defineProps({
        tile: Object,
        isActive: Boolean,
    })

    const iconSize = computed(() => {
        switch (props.tile?.IconSize) {
            case 'sm':
                return 'w-6 h-6'
            case 'md':
            default:
                return 'w-8 h-8'
            case 'lg':
                return 'w-12 h-12'
        }
    })

    const tileLink = computed(() => {
        return first(props.tile?.Link)
    })
</script>
